import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const initState = { email: "", password: "" };

const LoginForm = () => {
  const { login } = useAuth();
  const [state, setState] = useState(initState);
  const [error, setError] = useState("");

  const onChangeHandler = useCallback(
    (e) => {
      const { name, value } = e.currentTarget;
      setState({ ...state, [name]: value });
    },
    [state, setState]
  );

  const onLoginHandler = useCallback(async () => {
    setError("");
    const { email, password } = state;
    const res = await login({ email, password });
    if (!res?.success || !res?.data) {
      setError(res.message || "Error occurred. Please try again later.");
    }
  }, [state, login, setError]);

  const onKeyUpEnterHandler = useCallback(
    (e) => {
      if (e.key === "Enter") {
        onLoginHandler(e);
      }
    },
    [onLoginHandler]
  );

  return (
    <div className="card custom-card">
      <div className="card-body px-5">
        <div className="text-center">
          <img src="/logo-icon-only.png" width={33} height={40} alt="logo" />
        </div>
        <p id="errors" className="my-3 text-danger op-7 fw-normal text-center">
          {error}
        </p>
        <div className="row gy-3">
          <div className="col-xl-12">
            <input
              name="email"
              type="email"
              onChange={onChangeHandler}
              className="form-control form-control-lg"
              placeholder="Email"
            />
          </div>
          <div className="col-xl-12 mb-2">
            <div className="input-group">
              <input
                name="password"
                type="password"
                onKeyUp={onKeyUpEnterHandler}
                onChange={onChangeHandler}
                className="form-control form-control-lg"
                placeholder="Password"
              />
            </div>
          </div>
          <div className="mb-2 text-center">
            <a href="/#" className="fw-normal">
              Forgot password?
            </a>
          </div>
          <div className="col-xl-12 d-grid mt-2">
            <button className="btn btn-lg btn-primary" onClick={onLoginHandler}>
              Sign In
            </button>
          </div>
        </div>
        <div className="text-center my-3 authentication-barrier">
          <span>or</span>
        </div>
        <div className="col-xl-12 d-grid mt-2">
          <button className="btn btn-lg btn-light">Login with Microsoft</button>
        </div>
        <p className="text-center mt-5">ApproveShield &copy; 2024 </p>
      </div>
    </div>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
